// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"103":"81f665f2","178":"81f665f2","196":"77127869","480":"81f665f2"}[chunkId] + ".chunk.css";
};